<template>
  <div class="warp">
    <div style="height: 30px;float: left;line-height: 30px;width: 30px;margin-left: 5px" v-if="!($route.path === '/dataScreen' || $route.path === '/monitor')">
      <i :style="{color: moduletag === 2 ? '#7ebbfc' : '#1DD4FF'}" style="font-size: 30px;cursor: pointer" @click="changeOpen" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
    </div>
    <div style="height: 30px;max-width: calc(100% - 40px);float: left" @contextmenu.stop.prevent="$refs.ctxshow.showMenu($event)">
      <el-tabs :class="moduletag === 2 ? 'orgeltabs' : 'jujiatabs'" v-model="activeIndex"
        @tab-click='tabClick' @tab-remove='tabRemove' :closable="false">
        <el-tab-pane :key="item.name" v-for="item in openTab"
          :label="item.name" :name="item.route" :closable="!(openTab.length === 1)">
        </el-tab-pane>
      </el-tabs>
    </div>
    <e-vue-contextmenu ref="ctxshow" id="contextStyle" @ctx-show="show" @ctx-hide="hide">
      <div class="btn-close1" style="" @click="delTabAll">关闭其他</div>
      <div class="btn-close1" style="" @click="reloadPage">刷新</div>
    </e-vue-contextmenu>
  </div>
</template>

<script>
export default {
  name: 'orgNavWrap',
  data () {
    return {
      scene: '',
      isCollapse: false,
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.scene = this.$store.state.user.scene
  },
  mounted () {},
  computed: {
    openTab () {
      return this.$store.getters.openTab
    },
    activeIndex: {
      get () {
        return this.$store.getters.activeIndex
      },
      set (val) {
        this.$store.commit('set_active_index', val)
      }
    }
  },
  watch: {
    // 监听NavBar导航路由
    '$route' (to, from) {
      // console.log(this.$route.path, this.openTab)
      if (this.$route.path === '/dataScreen') {
        this.isCollapse = false // 默认展开
      }
      // 判断路由是否已经打开
      // 已经打开的 ，将其置为activeIndex
      // 未打开的，将其放入队列里
      let flag = false
      let sendname = to.name
      if (this.moduletag === 2) {
        if (to.path === '/monitor') {
          sendname = '数据大屏'
        } else if (to.path === '/serviceType') {
          sendname = '设置类别'
        } else if (to.path === '/serviceEvent') {
          sendname = '护理记录'
        }
      } else if (this.moduletag === 1) {
        if (to.path === '/community' && this.$store.state.user.moduletag === 1) {
          sendname = '小区管理'
        } else if (to.path === '/homeManagement' && this.$store.state.user.moduletag === 1) {
          sendname = '家庭管理'
        } else if (to.path === '/activityManagement') {
          sendname = '活动管理'
        }
      }
      this.$nextTick(() => {
        for (let i = 0; i < this.openTab.length; i++) {
          let item = this.openTab[i]
          if (item.name === sendname) {
            this.$store.commit('set_active_index', to.path)
            flag = true
            break
          }
        }
        if (!flag) {
          flag = false
          // 遍历一级路由，如果是一级路由就进行添加，否则就进行子路由跳转 index.js routes
          for (let i = 0; i < this.$router.options.routes[1].children.length; i++) {
            if (to.name === this.$router.options.routes[1].children[i].name) {
              flag = true
            }
          }
          if (flag) {
            let path = this.$route.path
            let role = this.$store.state.user.role
            let customerservicetag = this.$store.state.user.customerservicetag
            let moduletag = this.$store.state.user.moduletag
            let isOpenRoute = this.routejs.isOpenRoute(path, role, customerservicetag, moduletag)
            if (!isOpenRoute) {
              history.back()
              return
            }
            this.$store.commit('add_tabs', {route: to.path, name: sendname})
            this.$store.commit('set_active_index', to.path)
          }
        }
      })
    }
  },
  methods: {
    hideMenu () {
      this.$refs.ctxshow.hideMenu() // 隐藏菜单
    },
    show (data) {
      console.log('菜单显示了', data)
    },
    hide (data) {
      console.log('菜单隐藏了', data)
    },
    // tab标签点击时，切换相应的路由
    tabClick (tab) {
      // console.log(tab)
      console.log('二级菜单')
      let monitor = false
      if (this.$route.path === '/dataScreen' || this.$route.path === '/monitor') {
        monitor = true
      }
      this.$router.push({path: this.activeIndex})
      let obj = {
        type: 'path',
        path: this.activeIndex,
        monitor: monitor
      }
      this.$emit('changeMenu', obj) // home.vue
    },
    // 移除tab标签
    tabRemove (targetName) {
      this.$store.commit('delete_tabs', targetName)
      let monitor = false
      if (this.$route.path === '/monitor') {
        monitor = true
      }
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTab && this.openTab.length >= 1) {
          this.$store.commit('set_active_index', this.openTab[this.openTab.length - 1].route)
          this.$router.push({path: this.activeIndex})
          let obj = {
            type: 'path',
            path: this.activeIndex,
            monitor: monitor
          }
          this.$emit('changeMenu', obj) // home.vue
        }
      }
    },
    // {route: to.path, name: to.name}
    delTabAll () {
      let arr = this.openTab
      for (let i = 0; i < arr.length; i++) {
        if (this.$route.path === arr[i].route) {
          this.$store.commit('delete_tabs_all', {route: arr[i].route, name: arr[i].name})
        }
      }
      this.$refs.ctxshow.hideMenu() // 隐藏菜单
    },
    reloadPage () {
      location.reload()
      this.$refs.ctxshow.hideMenu() // 隐藏菜单
    },
    changeOpen () {
      this.isCollapse = !this.isCollapse
      let obj = {
        type: 'isCollapse'
      }
      this.$emit('changeMenu', obj)
    }
  }
}
</script>

<style scoped>
/*.btn-close{
  cursor: pointer;
  float: left;
  height: 28px;
  line-height: 28px;
  text-align: center;
  width: 70px;
  border-radius: 6px;
  border: 1px solid #7ebbfc;
  font-size: 14px;
  color: #7ebbfc;
}*/
.btn-close1{
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
}
.btn-close1:hover{
  color: #7ebbfc;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/childNavBar/orgNavWrap.vue